var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"errorimg"}),_c('div',{staticClass:"errortext"},[_vm._v("登录出错.....")]),_c('a',{staticClass:"fanhui",on:{"click":_vm.clickLeft}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }